"use client";

import type { PropsWithChildren } from "react";

import { cn } from "../../utils/cn.util";
import { StickyWrapper } from "../sticky-wrapper";

export interface LayoutContentHeaderProps extends PropsWithChildren {
  className?: string;
}

const ContentHeader = ({ children, className }: LayoutContentHeaderProps) => {
  return (
    <StickyWrapper>
      <nav className={cn("flex w-full flex-col bg-white", className)}>{children}</nav>
    </StickyWrapper>
  );
};

export default ContentHeader;
